import { render, staticRenderFns } from "./started-header.vue?vue&type=template&id=1ba2d314&scoped=true&"
import script from "./started-header.vue?vue&type=script&lang=js&"
export * from "./started-header.vue?vue&type=script&lang=js&"
import style0 from "./started-header.vue?vue&type=style&index=0&id=1ba2d314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba2d314",
  null
  
)

export default component.exports